export enum DiagnosticStatus {
  InviteSent = 0,
  InviteRejected = 1,
  InviteAccepted = 2,
  InProgress = 3,
  Finished = 4,
  CancelledByInvestor = 5,
  CancelledByInviteExpired = 6,
  CancelledByNotFinishedInTime = 7,
}
